/**
 *
 * DASHBOARD-AXES-OVERVIEW.WIDGET
 *
 */

import { connect } from "react-redux"
import { Axis } from "../redux/axis.types"
import { Session } from "../redux/_session.types"
import { useEffect, useState } from "react"
import { useCountUpList } from "@/utils/use-count-up.utils"

interface StateProps {
  _session: Session
}

interface OwnProps {
  axes: Axis[]
  onClick?: Function
  isFullWidth?: boolean
  isPreview?: boolean
}

type Props = StateProps & OwnProps

function DashboardAxesOverviewWidget(props: Props) {
  const [axes, setAxes] = useState<Axis[]>(props.axes)
  const [axesTextLength, setAxesTextLength] = useState<number>(0) //If text too long hide images

  useEffect(() => {
    setAxes(props.axes)
    //Set max text width
    setAxesTextLength(Math.max(...props.axes.map((x) => x.label.length)))
  }, [props.axes])

  const filteredAxes = axes.filter((x) => x.note)
  const animatedNotes = useCountUpList(filteredAxes.map((x) => x.note))

  function getNoteLabel(note: number): string {
    return props._session.dashboardDisplaySettings.dashboardDisplayMode === "note"
      ? (note / 10).toFixed(1)
      : note.toFixed(0) + "%"
  }

  function click(axis: Axis) {
    if (props.onClick) {
      props.onClick(axis)
    }
  }

  //Error image
  function onErrorImage(axis) {
    axis.image = null
    setAxes(axes.map((x) => (x.id === axis ? axis : x)))
  }

  return (
    <div
      className={!props.isFullWidth ? "" : "flex flex-wrap"}
      style={{
        height: props.isPreview && !props.isFullWidth ? 320 : undefined,
        width: props.isPreview ? (props.isFullWidth ? 580 : 290) : undefined
      }}>
      {
        // here new widget
        filteredAxes.map((axis: Axis, i: number) => (
          <div className="flex" style={{ width: props.isFullWidth ? "50%" : "100%" }} key={axis.id}>
            <div className="flex1 podium-text flex">
              {axesTextLength < 38 &&
                (axis.image ? (
                  <img
                    alt="axis"
                    className="results-axis-img"
                    onError={() => onErrorImage(axis)}
                    src={axis.picture}></img>
                ) : (
                  <div style={{ backgroundColor: axis.color }} className="podium-pastille"></div>
                ))}

              <div
                onClick={() => click(axis)}
                style={{
                  marginLeft: 16
                }}
                className="podium-text-label flex1">
                {axis.label}
              </div>
            </div>

            <div
              className="podium-note"
              style={{
                color: axis.color,
                paddingRight: 12
              }}>
              <b>{getNoteLabel(animatedNotes[i])}</b>
            </div>
          </div>
        ))
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(DashboardAxesOverviewWidget)
